import { SyntheticEvent } from "react";
import { Nav, Sidenav } from "rsuite";
import { getMenuIcon } from "../../../utils/helpers";
export function SideMenu({
  menu,
  onSelect,
  activePath,
}: {
  menu: any;
  onSelect: any;
  activePath: string;
}) {
  function TitleNode(title: string) {
    return <div>{title}</div>;
  }

  function isMenuActive(activePath: string, child: Array<any>) {
    let isMenu = child.find((item) => `/${item.menu_url}` === activePath);
    if (isMenu) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <Sidenav.Body>
      <Nav>
        {menu.map((item: any, index: number) => {
          let menuIcon = getMenuIcon(item?.menu_icon);

          let parentIcon = menuIcon ? { icon: menuIcon } : {};

          return item.child.length <= 0 ? (
            <Nav.Item
              key={item.menu_url}
              eventKey={item.menu_url}
              title={item.menu_label}
              active={activePath === `/${item.menu_url}`}
              onSelect={(
                eventKey: string | undefined,
                event: SyntheticEvent<Element, Event>
              ) => {
                onSelect(eventKey, item.page_type);
              }}
              {...parentIcon}
            >
              {item.menu_label}
            </Nav.Item>
          ) : (
            <Nav.Menu
              key={index}
              eventKey="3"
              trigger="hover"
              // title={<TitleNode title={item.menu_label} />}
              title={
                <div
                  className={
                    isMenuActive(activePath, item.child) ? "active-menu" : ""
                  }
                >
                  {item.menu_label}
                </div>
              }
              placement="rightStart"
              {...parentIcon}
            >
              {item.child.map((child: any) => {
                let childMenuIcon = getMenuIcon(child?.menu_icon);

                let childIcon = childMenuIcon ? { icon: childMenuIcon } : {};
                return (
                  <Nav.Item
                    key={child.menu_url}
                    active={activePath === `/${child.menu_url}`}
                    onSelect={(
                      eventKey: string | undefined,
                      event: SyntheticEvent<Element, Event>
                    ) => {
                      onSelect(eventKey, child.page_type);
                    }}
                    eventKey={child.menu_url}
                    {...childIcon}
                  >
                    {child.menu_label}
                  </Nav.Item>
                );
              })}
            </Nav.Menu>
          );
        })}
      </Nav>
    </Sidenav.Body>
  );
}
